import React, { useEffect, useCallback } from 'react';

const PreviewModal = ({ isOpen, onClose, imageSrc, alt }) => {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return;
    
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4" 
      onClick={onClose}
    >
      <div className="relative w-full h-full flex items-center justify-center">
        <div 
          className="relative bg-white rounded-lg overflow-hidden max-w-6xl w-full max-h-[90vh] my-8" 
          onClick={e => e.stopPropagation()}
        >
          <div className="overflow-auto h-full max-h-[85vh]">
            <img 
              src={imageSrc} 
              alt={alt} 
              className="w-full h-auto block"
            />
          </div>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white bg-black bg-opacity-50 rounded-full w-12 h-12 flex items-center justify-center hover:bg-opacity-75 transition-colors text-2xl z-10"
            aria-label="关闭"
          >
            ×
          </button>
        </div>
      </div>
      <div className="absolute bottom-4 left-4 right-4 text-center text-white text-sm bg-black bg-opacity-50 px-4 py-2 rounded">
        使用 ESC 键退出，滚动查看完整图片
      </div>
    </div>
  );
};

export default PreviewModal;